import { ActionContext, ActionTree, GetterTree } from 'vuex';

export interface StaffData {
  kyotenCd: string;
  kyotenNm: string;
  results: boolean;
  staffCd: string;
  staffNm: string;
}

export interface State {
  staffData: StaffData;
  token: string;
  loginTypeKbn: string;
}

// for initial data
const initialState: State = {
  staffData: {
    kyotenCd: '',
    kyotenNm: '',
    results: false,
    staffCd: '',
    staffNm: '',
  },
  token: '',
  loginTypeKbn: '',
};

// for stored data
const states: State = {
  ...initialState,
};

const actions: ActionTree<any, any> = {
  setToken({ commit }: ActionContext<State, string>, payload: string): void {
    commit('setToken', payload);
  },
  getToken({ commit }: ActionContext<State, any>): void {
    commit('getToken');
  },
  resetToken({ commit }: ActionContext<State, any>): void {
    commit('resetToken');
  },
  setStaffData({ commit }: ActionContext<State, any>, payload: StaffData): void {
    commit('setStaffData', payload);
  },
  getStaffData({ commit }: ActionContext<State, any>): void {
    commit('getStaffData');
  },
  resetStaffData({ commit }: ActionContext<State, any>): void {
    commit('resetStaffData');
  },
  setLoginTypeKbn({ commit }: ActionContext<State, string>, payload: string): void {
    commit('setLoginTypeKbn', payload);
  },
  getLoginTypeKbn({ commit }: ActionContext<State, any>): void {
    commit('getLoginTypeKbn');
  },
  resetLoginTypeKbn({ commit }: ActionContext<State, any>): void {
    commit('resetLoginTypeKbn');
  },
};

const mutations = {
  setToken(state: State, payload: string) {
    state.token = payload;
    localStorage.setItem("token", payload);
  },
  resetToken(state: State) {
    state.token = initialState.token;
  },

  setStaffData(state: State, payload: StaffData) {
    state.staffData = { ...payload };
  },
  resetStaffData(state: State) {
    state.staffData = { ...initialState.staffData };
  },

  setLoginTypeKbn(state: State, payload: string) {
    state.loginTypeKbn = payload;
  },
  resetLoginTypeKbn(state: State) {
    state.loginTypeKbn = initialState.loginTypeKbn;
  },

};

const getters: GetterTree<State, any> = {
  getToken(state): string {
    return state.token;
  },
  getStaffData(state): StaffData {
    return state.staffData;
  },
  isNotAdmin(state): boolean {
    if (state.loginTypeKbn && (state.loginTypeKbn == "1")) {
      return false;
    }
    return true;
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: states,
  getters,
  actions,
  mutations,
};
